export default __webpack_public_path__ + "static/pragicts-itops-capacity-plannig-31bcc9d1b38c3b2b75c528d37694b3ca.jpg";